import {useState} from 'react';
import {Button, Checkbox, DatePicker, Form, Input, Tooltip} from 'antd';
import {useNavigate} from 'react-router-dom';
import SERVICES from 'services';
import moment from 'moment';
import {Question} from 'phosphor-react';
import {ltrim} from 'components/formItems/FormGroup/FormGroup';

const Register = () => {
	const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
	const [inputErrors, setInputErrors] = useState<any>({});
	const [checked, setChecked] = useState(false);

	const navigate = useNavigate();

	const onFinish = (values: any) => {
		values.dob = moment(values.dob).format('YYYY-MM-DD');
		values.competitionTypeID = values.competitionTypeID ? 2 : 1;
		delete values.agreeWithTaC;
		setIsSubmitting(true);
		setInputErrors({});

		SERVICES.AUTH.register(values)
			.then(() => {
				navigate('/confirm', {replace: true, state: {from: 'register'}});
			})
			.catch(err => {
				let errMessage = null;
				if (typeof err.message !== 'string') {
					errMessage = err.message;
				}
				setIsSubmitting(false);
				setInputErrors(errMessage);
			});
	};

	return (
		<div className="formContainer registerContainer">
			<div className="formContainer_title">
				<span>Գրանցում</span>
				<div id="divider" />
			</div>
			<Form className="formContainer_form" layout="vertical" onFinish={onFinish} autoComplete="off">
				<Form.Item
					name="name"
					validateStatus={inputErrors?.name ? 'error' : undefined}
					getValueFromEvent={(val: any) => ltrim(val.target.value)}
					help={inputErrors?.name}
					rules={[
						{required: true, message: 'Մուտքագրեք Ձեր անունը'},
						{pattern: new RegExp('^[Ա-Ֆա-ֆ-և0-9/-<> ]{1,100}$'), message: 'Միայն հայատառ մուտք'}
					]}>
					<Input placeholder="Անուն (հայատառ)" className="formContainer_form_input" />
				</Form.Item>
				<Form.Item
					name="lastname"
					validateStatus={inputErrors?.lastname ? 'error' : undefined}
					getValueFromEvent={(val: any) => ltrim(val.target.value)}
					help={inputErrors?.lastname}
					rules={[
						{required: true, message: 'Մուտքագրեք Ձեր ազգանունը'},
						{pattern: new RegExp('^[Ա-Ֆա-ֆ-և0-9/-<> ]{1,100}$'), message: 'Միայն հայատառ մուտք'}
					]}>
					<Input placeholder="Ազգանուն (հայատառ)" className="formContainer_form_input" />
				</Form.Item>
				<Form.Item
					name="middleName"
					validateStatus={inputErrors?.lastname ? 'error' : undefined}
					getValueFromEvent={(val: any) => ltrim(val.target.value)}
					help={inputErrors?.lastname}
					rules={[
						{required: true, message: 'Մուտքագրեք Ձեր հայրանունը'},
						{pattern: new RegExp('^[Ա-Ֆա-ֆ-և0-9/-<> ]{1,100}$'), message: 'Միայն հայատառ մուտք'}
					]}>
					<Input placeholder="Հայրանուն (հայատառ)" className="formContainer_form_input" />
				</Form.Item>
				<Form.Item
					name="telephone"
					validateStatus={inputErrors?.telephone ? 'error' : undefined}
					getValueFromEvent={(val: any) => ltrim(val.target.value)}
					help={inputErrors?.telephone}
					rules={[{required: true, message: 'Մուտքագրեք Ձեր հեռախոսահամարը'}]}>
					<Input
						prefix="+"
						placeholder="000 00 000-000"
						type="tel"
						className="formContainer_form_input"
					/>
				</Form.Item>

				<Form.Item
					name="dob"
					validateStatus={inputErrors?.dob ? 'error' : undefined}
					help={inputErrors?.dob}
					rules={[{required: true, message: 'Մուտքագրեք Ձեր ծննդյան ամսաթիվը'}]}>
					<DatePicker
						format="DD-MM-YYYY"
						placeholder="Ծննդյան ամսաթիվ (DD-MM-YYYY)"
						className="formContainer_form_input"
						style={{width: '100%'}}
					/>
				</Form.Item>
				<Form.Item
					name="email"
					validateStatus={inputErrors?.email ? 'error' : undefined}
					getValueFromEvent={(val: any) => ltrim(val.target.value)}
					help={inputErrors?.email}
					dependencies={['c_email']}
					rules={[{required: true, message: 'Մուտքագրեք Ձեր էլ․ հասցեն'}]}>
					<Input placeholder="Էլ․ փոստ" className="formContainer_form_input" />
				</Form.Item>
				<Form.Item
					name="c_email"
					validateStatus={inputErrors?.email ? 'error' : undefined}
					getValueFromEvent={(val: any) => ltrim(val.target.value)}
					help={inputErrors?.email}
					dependencies={['email']}
					rules={[
						({getFieldValue}) => ({
							validator(_, value) {
								if (!value || getFieldValue('email') === value) {
									return Promise.resolve();
								}
								return Promise.reject(
									new Error('Ձեր մուտքագրած էլ․ հասցեները չեն համընկնում։')
								);
							}
						}),
						{required: true, message: 'Մուտքագրեք Ձեր էլ․ հասցեն'}
					]}>
					<Input
						onPaste={e => {
							e.preventDefault();
						}}
						placeholder="Կրկնեք Էլ․ փոստը"
						className="formContainer_form_input"
					/>
				</Form.Item>
				<Form.Item
					name="password"
					validateStatus={inputErrors?.password ? 'error' : undefined}
					getValueFromEvent={(val: any) => ltrim(val.target.value)}
					help={inputErrors?.password}
					dependencies={['c_password']}
					rules={[{required: true, message: 'Մուտքագրեք Ձեր գաղտնաբառը'}]}>
					<Input.Password
						placeholder="Գաղտնաբառ"
						className="formContainer_form_input"
						prefix={
							<Tooltip
								title="Գաղտնաբառը պետք է պարունակի առնվազն 6 նիշ՝
							մեծատառ, փոքրատառ, թիվ կամ նշան">
								<Question size={16} weight="thin" />
							</Tooltip>
						}
					/>
				</Form.Item>
				<Form.Item
					name="c_password"
					dependencies={['password']}
					getValueFromEvent={(val: any) => ltrim(val.target.value)}
					validateStatus={inputErrors?.password ? 'error' : undefined}
					help={inputErrors?.password}
					rules={[
						{required: true, message: 'Կրկնեք Ձեր գաղտնաբառը'},
						({getFieldValue}) => ({
							validator(_, value) {
								if (!value || getFieldValue('password') === value) {
									return Promise.resolve();
								}
								return Promise.reject(
									new Error('Ձեր մուտքագրած գաղտնաբառերը չեն համընկնում')
								);
							}
						})
					]}>
					<Input.Password placeholder="Կրկնեք գաղտնաբառը" className="formContainer_form_input" />
				</Form.Item>
				<Form.Item name="competitionTypeID" valuePropName="checked">
					<Checkbox>Մասնակցում եմ օտարերկրացի դիմորդների ընդունելությանը</Checkbox>
				</Form.Item>
				<Form.Item
					validateFirst
					rules={[
						{
							validator() {
								if (checked) {
									return Promise.resolve();
								}
								return Promise.reject();
							},
							message: 'Խնդրում ենք ծանոթանալ ընդունելության կանոնակարգին'
						}
					]}
					name="agreeWithTaC"
					valuePropName="checked">
					<Checkbox checked={checked} onChange={() => setChecked(prev => !prev)}>
						Հաստատում եմ, որ ծանոթացել եմ{' '}
						<a
							target="_blank"
							rel="noreferrer"
							href="https://ufar.am/storage/uploads/Reglement_admission_licence_2026-2027_rotated.pdf">
							ընդունելության կանոնակարգին
						</a>
					</Checkbox>
				</Form.Item>
				<Form.Item style={{textAlign: 'center'}}>
					<Button
						className="formContainer_form_button"
						type="primary"
						htmlType="submit"
						loading={isSubmitting}>
						Գրանցվել
					</Button>
				</Form.Item>
			</Form>
			<div className="formContainer_footer">
				<span>Արդեն գրանցվա՞ծ եք։</span>
				<a href="/login">Մուտք գործել</a>
			</div>
		</div>
	);
};

export default Register;
